import { type AllergenOrDietaryRestriction } from '../../../utils/dietary-preferences';
import { type DietaryPreferencesTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function sortPreferencesByName(preferences: DietaryPreferencesTypes) {
  const preferencesNames = Object.keys(preferences);
  const sortedPreferences = [...preferencesNames].sort(compareAlphabetically);

  return sortedPreferences as AllergenOrDietaryRestriction[];
}

// ─────────────────────────────────────────────────────────────────────────────

function compareAlphabetically(preference: string, nextPreference: string) {
  return preference.localeCompare(nextPreference);
}
